import { render, staticRenderFns } from "./OnboardingChatbot.vue?vue&type=template&id=29b23b4e&scoped=true"
import script from "./OnboardingChatbot.vue?vue&type=script&lang=js"
export * from "./OnboardingChatbot.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChatbot.scss?vue&type=style&index=0&id=29b23b4e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b23b4e",
  null
  
)

export default component.exports